import Const from 'constants';
import AppLocalStorage from 'storages/app-local-storage';
import UserAgent from './device';
import NumberHelper from 'helpers/number-helper';
import {BASE_PATH} from 'config';

export function calculatePlayersRange(players, field, helpers = {}) {
    const {parseValue = (value) => value, shouldPlayerBeSkipped = () => false} = helpers;

    players = players || {};

    let min = null;
    let max = null;
    let initiated = false;

    for (const player of Object.values(players)) {
        if (shouldPlayerBeSkipped(player)) {
            continue;
        }

        const itemValue = parseValue(player[field]);

        if (!initiated) {
            min = itemValue;
            max = itemValue;
            initiated = true;
        }

        if (min > itemValue) {
            min = itemValue;
        }

        if (max < itemValue) {
            max = itemValue;
        }
    }

    return {min, max};
}

export function calcValByPct(quantity, percent, toFixed = 2) {
    if (quantity > 0 && percent > 0) {
        const value = (quantity * percent) / 100;

        return parseFloat(value.toFixed(toFixed));
    }

    return 0;
}

export function calcAndRoundDownValByPct(quantity, percent) {
    if (quantity > 0 && percent > 0) {
        let result = (quantity * percent) / 100;
        return Math.floor(result);
    }
    return 0;
}

export function calcAndRoundUpValByPct(quantity, percent) {
    if (quantity > 0 && percent > 0) {
        let result = (quantity * percent) / 100;
        return Math.ceil(result);
    }
    return 0;
}

export function calcPercentage(x, y, toFixed = 2) {
    if (x > 0 && y > 0) {
        let result = (y / x) * 100;
        return NumberHelper.float(result, toFixed);
    }
    return 0;
}

export function inRange(value, min, max) {
    return value >= min && value <= max;
}

export function filterObjectByParams(object, filterBy, toArray = false) {
    const result = toArray ? [] : {};

    Object.keys(object).map((key) => {
        let save = true;
        for (let filterField in filterBy) {
            const {filterType, filterValue, orFilterFields, callback, dataItemCallback, addConditionCallback} =
                filterBy[filterField];

            if (typeof object[key][filterField] === 'undefined' || filterValue === '*') {
                continue;
            }

            const itemObject = object[key];
            const item =
                typeof dataItemCallback === 'function'
                    ? dataItemCallback(itemObject[filterField])
                    : itemObject[filterField];

            if (filterType === Const.FILTER_TYPE_EQUAL) {
                filterValue !== item && (save = false);
            } else if (filterType === Const.FILTER_TYPE_NOT_EQUAL) {
                filterValue === item && (save = false);
            } else if (filterType === Const.FILTER_TYPE_EQUAL_LESS) {
                item >= filterValue && (save = false);
            } else if (filterType === Const.FILTER_TYPE_EQUAL_MORE) {
                item <= filterValue && (save = false);
            } else if (filterType === Const.FILTER_TYPE_LESS) {
                item > filterValue && (save = false);
            } else if (filterType === Const.FILTER_TYPE_MORE) {
                item < filterValue && (save = false);
            } else if (filterType === Const.FILTER_TYPE_LIKE) {
                save = !(String(item).toLowerCase().indexOf(filterValue.toLowerCase()) < 0);
            } else if (filterType === Const.FILTER_TYPE_IN_ARRAY) {
                save = !(Array.isArray(filterValue) && !inArray(item, filterValue));
            } else if (filterType === Const.FILTER_TYPE_NOT_IN_ARRAY) {
                if (Array.isArray(filterValue) && inArray(item, filterValue)) {
                    save = typeof addConditionCallback === 'function' ? addConditionCallback(itemObject) : false;
                }
            } else if (filterType === Const.FILTER_TYPE_ARRAY_HAS_VALUE) {
                save = !(Array.isArray(item) && !inArray(filterValue, item));
            } else if (filterType === Const.FILTER_TYPE_ARRAY_HAS_DUPLICATES) {
                save =
                    Array.isArray(item) && Array.isArray(filterValue)
                        ? !arrayDuplicates(item, filterValue).length
                        : false;
            } else if (filterType === Const.FILTER_TYPE_ARRAY_HAS_NO_DUPLICATES) {
                save =
                    Array.isArray(item) && Array.isArray(filterValue)
                        ? arrayDuplicates(item, filterValue).length
                        : false;
            } else if (filterType === Const.FILTER_TYPE_RANGE) {
                if (filterValue.hasOwnProperty('min') && filterValue.hasOwnProperty('max')) {
                    if (parseFloat(item) < filterValue.min || parseFloat(item) > filterValue.max) {
                        save = false;
                    }
                }
            } else if (filterType === Const.FILTER_TYPE_OR_MANY_FIELDS) {
                save = false;
                for (let index in orFilterFields) {
                    if (filterValue === object[key][orFilterFields[index]]) {
                        save = true;
                    }
                }
            } else if (filterType === Const.FILTER_TYPE_CALLBACK) {
                save = typeof callback === 'function' ? callback(itemObject) : false;
            }

            if (!save) {
                return;
            }
        }

        if (toArray) {
            result.push(object[key]);
        } else {
            result[key] = object[key];
        }
    });

    // for (let id in object) {
    //     let save = true;
    //     for (let filterField in filterBy) {
    //         const {
    //             filterType,
    //             filterValue,
    //             orFilterFields,
    //             callback,
    //             dataItemCallback,
    //             addConditionCallback,
    //         } = filterBy[filterField];
    //
    //         if (typeof object[id][filterField] === 'undefined' || filterValue === '*') {
    //             continue;
    //         }
    //
    //         const itemObject = object[id];
    //         const item = (typeof dataItemCallback === 'function')
    //             ? dataItemCallback(itemObject[filterField])
    //             : itemObject[filterField];
    //
    //         switch (filterType) {
    //             case Const.FILTER_TYPE_EQUAL:
    //                 if (filterValue !== item) {
    //                     save = false;
    //                 }
    //                 break;
    //             case Const.FILTER_TYPE_NOT_EQUAL:
    //                 if (filterValue === item) {
    //                     save = false;
    //                 }
    //                 break;
    //             case Const.FILTER_TYPE_EQUAL_LESS:
    //                 if (item >= filterValue) {
    //                     save = false;
    //                 }
    //                 break;
    //             case Const.FILTER_TYPE_EQUAL_MORE:
    //                 if (item <= filterValue) {
    //                     save = false;
    //                 }
    //                 break;
    //             case Const.FILTER_TYPE_LESS:
    //                 if (item > filterValue) {
    //                     save = false;
    //                 }
    //                 break;
    //             case Const.FILTER_TYPE_MORE:
    //                 if (item < filterValue) {
    //                     save = false;
    //                 }
    //                 break;
    //             case Const.FILTER_TYPE_LIKE:
    //                 if (String(item).toLowerCase().indexOf(filterValue.toLowerCase()) < 0) {
    //                     save = false;
    //                 }
    //                 break;
    //             case Const.FILTER_TYPE_IN_ARRAY:
    //                 if (Array.isArray(filterValue)) {
    //                     if (!inArray(item, filterValue)) {
    //                         save = false;
    //                     }
    //                 }
    //                 break;
    //             case Const.FILTER_TYPE_NOT_IN_ARRAY:
    //                 if (Array.isArray(filterValue)) {
    //                     if (inArray(item, filterValue)) {
    //                         save = false;
    //
    //                         if (typeof addConditionCallback === 'function') {
    //                             save = addConditionCallback(itemObject);
    //                         }
    //                     }
    //                 }
    //                 break;
    //             case Const.FILTER_TYPE_ARRAY_HAS_VALUE:
    //                 if (Array.isArray(item)) {
    //                     if (!inArray(filterValue, item)) {
    //                         save = false;
    //                     }
    //                 }
    //                 break;
    //             case Const.FILTER_TYPE_ARRAY_HAS_DUPLICATES:
    //                 save = false;
    //                 if (Array.isArray(item) && Array.isArray(filterValue)) {
    //                     save = !arrayDuplicates(item, filterValue).length;
    //                 }
    //                 break;
    //             case Const.FILTER_TYPE_ARRAY_HAS_NO_DUPLICATES:
    //                 save = false;
    //                 if (Array.isArray(item) && Array.isArray(filterValue)) {
    //                     save = arrayDuplicates(item, filterValue).length;
    //                 }
    //                 break;
    //             case Const.FILTER_TYPE_RANGE:
    //                 if (filterValue.hasOwnProperty('min') && filterValue.hasOwnProperty('max')) {
    //                     if (parseFloat(item) < filterValue.min || parseFloat(item) > filterValue.max) {
    //                         save = false;
    //                     }
    //                 }
    //                 break;
    //             case Const.FILTER_TYPE_OR_MANY_FIELDS:
    //                 save = false;
    //                 for (let index in orFilterFields) {
    //                     if (filterValue === object[id][orFilterFields[index]]) {
    //                         save = true;
    //                     }
    //                 }
    //                 break;
    //             case Const.FILTER_TYPE_CALLBACK:
    //                 save = false;
    //                 if (typeof callback === 'function') {
    //                     save = callback(itemObject);
    //                 }
    //                 break;
    //         }
    //
    //         if (!save) {
    //             break;
    //         }
    //     }
    //
    //     if (save) {
    //         if (toArray) {
    //             result.push(object[id]);
    //         } else {
    //             result[id] = object[id];
    //         }
    //     }
    // }

    return result;
}

export function sortArrayOfObjects(arrayOfObjects, sortBy, direction) {
    const getValue = typeof sortBy === 'function' ? (obj) => sortBy(obj) : (obj) => obj[sortBy];

    return arrayOfObjects.sort((a, b) => {
        const aValue = getValue(a);
        const bValue = getValue(b);

        if (typeof aValue === 'number') {
            return direction === 'desc' ? bValue - aValue : aValue - bValue;
        }

        const result = new Intl.Collator().compare(aValue, bValue, 'en');

        return direction === 'desc' ? -1 * result : result;
    });
}

export function initSportConfig() {
    const result = {
        sport: '',
        site: '',
        gameType: '',
        slateId: '',
        mode: '',
    };

    let sportConfigFilters = AppLocalStorage.getValue('sportConfigFilters');

    if (!sportConfigFilters.length) {
        return result;
    }

    sportConfigFilters = JSON.parse(sportConfigFilters);

    if (!sportConfigFilters.hasOwnProperty(BASE_PATH)) {
        return result;
    }

    sportConfigFilters = sportConfigFilters[BASE_PATH];

    if (sportConfigFilters.hasOwnProperty('sport')) {
        result.sport = sportConfigFilters.sport;
        result.site = sportConfigFilters.site;
        result.gameType = sportConfigFilters.gameType;
        result.mode = sportConfigFilters.mode;
        if (UserAgent.isMobile() && result.mode !== 'lateswap') {
            result.slateId = sportConfigFilters.slateId;
        }
    }

    return result;
}

export function calcUserScore(userPoints, salary, multiplyBy = 1000) {
    const userScore = parseFloat((userPoints / salary) * multiplyBy).toFixed(2);

    return parseFloat(userScore);
}

export function getValue(obj, property, defaultValue = null) {
    if (obj && obj.hasOwnProperty(property)) {
        return obj[property];
    }
    return defaultValue;
}

export function getCssStylesByParams(params) {
    const {config, value} = params;
    if (config.hasOwnProperty(value)) {
        const color = config[value];

        return {'--_cell-color': color};
    }
    return {};
}

export function getCellBgColor(value, rules) {
    let range, point, percent;
    let color = false;
    if (typeof rules === 'undefined') {
        return {};
    }

    if (isEmpty(rules.middle)) {
        range = parseFloat(rules.range.max) - parseFloat(rules.range.min);
        point = parseFloat(value) - parseFloat(rules.range.min);
        percent = rules.isReverted ? (1 - point / range) * 100 : (point / range) * 100;

        color = getFullGradientColor(percent);
    } else {
        if (parseFloat(value) >= parseFloat(rules.middle.min) && parseFloat(value) <= parseFloat(rules.middle.max)) {
            color = rules.middle.isUnshaded ? false : getYellowGradientColor();
        } else if (parseFloat(value) < parseFloat(rules.middle.min)) {
            range = parseFloat(rules.middle.min) - parseFloat(rules.range.min);
            point = parseFloat(value) - parseFloat(rules.range.min);
            percent = rules.isReverted ? ((1 - point / range) * 100).toFixed(2) : ((point / range) * 100).toFixed(2);

            if (rules.isReverted) {
                color = getGreenGradientColor(percent);
            } else {
                color = getRedGradientColor(percent);
            }
        } else if (parseFloat(value) > parseFloat(rules.middle.max)) {
            range = parseFloat(rules.range.max) - parseFloat(rules.middle.max);
            point = parseFloat(value) - parseFloat(rules.middle.max);
            percent = rules.isReverted ? ((1 - point / range) * 100).toFixed(2) : ((point / range) * 100).toFixed(2);

            if (rules.isReverted) {
                color = getRedGradientColor(percent);
            } else {
                color = getGreenGradientColor(percent);
            }
        }
    }

    return color && {'--_cell-color': color};
}

function getFullGradientColor(percent) {
    switch (true) {
        case percent <= 5:
            return 'rgb(230, 120, 110)';
        case 5 <= percent && percent <= 15:
            return 'rgb(234, 144, 118)';
        case 15 <= percent && percent <= 25:
            return 'rgb(238, 168, 126)';
        case 25 <= percent && percent <= 35:
            return 'rgb(242, 192, 134)';
        case 35 <= percent && percent <= 45:
            return 'rgb(246, 216, 142)';
        case 45 <= percent && percent <= 55:
            return 'rgb(250, 240, 150)';
        case 55 <= percent && percent <= 65:
            return 'rgb(220, 230, 148)';
        case 65 <= percent && percent <= 75:
            return 'rgb(190, 220, 146)';
        case 75 <= percent && percent <= 85:
            return 'rgb(160, 210, 144)';
        case 85 <= percent && percent <= 95:
            return 'rgb(130, 200, 142)';
        case 95 <= percent:
            return 'rgb(100, 190, 140)';
        default:
            return false;
    }
}

function getRedGradientColor(percent) {
    switch (true) {
        case percent <= 20:
            return 'rgb(230, 120, 110)';
        case 20 <= percent && percent <= 40:
            return 'rgb(234, 144, 118)';
        case 40 <= percent && percent <= 60:
            return 'rgb(238, 168, 126)';
        case 60 <= percent && percent <= 80:
            return 'rgb(242, 192, 134)';
        case 80 <= percent:
            return 'rgb(246, 216, 142)';
        default:
            return false;
    }
}

function getGreenGradientColor(percent) {
    switch (true) {
        case percent <= 20:
            return 'rgb(220, 230, 148)';
        case 20 <= percent && percent <= 40:
            return 'rgb(190, 220, 146)';
        case 40 <= percent && percent <= 60:
            return 'rgb(160, 210, 144)';
        case 60 <= percent && percent <= 80:
            return 'rgb(130, 200, 142)';
        case 80 <= percent:
            return 'rgb(100, 190, 140)';
        default:
            return false;
    }
}

function getYellowGradientColor() {
    return 'rgb(250, 240, 150)';
}

export function getValuesAsPercent(value) {
    return (value * 100).toFixed(1) * 1;
}
